import getAPI from './getAPI.js'

export default async function getTenantTaskInstances() {
    const data = await getAPI('taskinstances');
    return data;
}
